export default __webpack_public_path__ + "static/media/initial-page-backgroud.00decabf.svg";